"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCourseImportStatus = exports.startCourseImport = exports.deleteCourseImportMapping = exports.getCourseImportMapping = exports.getCourseImportMappings = exports.saveCourseImportMapping = exports.AnalyzeCourseImportFile = exports.PreviewCourseImportFile = exports.UploadCourseImportFile = void 0;
var HttpClient_1 = require("../core/HttpClient");
var UploadCourseImportFile = function (school_id, formData) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/course-import/upload"), formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};
exports.UploadCourseImportFile = UploadCourseImportFile;
var PreviewCourseImportFile = function (school_id, file_id) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/course-import/preview"), {
        file_id: file_id,
    });
};
exports.PreviewCourseImportFile = PreviewCourseImportFile;
var AnalyzeCourseImportFile = function (school_id, file_id, column_mapping) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/course-import/analyze"), {
        file_id: file_id,
        column_mapping: column_mapping,
    });
};
exports.AnalyzeCourseImportFile = AnalyzeCourseImportFile;
var saveCourseImportMapping = function (school_id, name, mapping) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/course-import/mappings"), {
        school_id: school_id,
        name: name,
        mapping: mapping,
    });
};
exports.saveCourseImportMapping = saveCourseImportMapping;
var getCourseImportMappings = function (school_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/course-import/mappings"));
};
exports.getCourseImportMappings = getCourseImportMappings;
var getCourseImportMapping = function (school_id, mapping_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/course-import/mappings/").concat(mapping_id));
};
exports.getCourseImportMapping = getCourseImportMapping;
var deleteCourseImportMapping = function (school_id, mapping_id) {
    return HttpClient_1.HttpClient.delete("/schools/".concat(school_id, "/course-import/mappings/").concat(mapping_id));
};
exports.deleteCourseImportMapping = deleteCourseImportMapping;
var startCourseImport = function (school_id, file_id, test, column_mapping, course_type_mapping, instructor_mapping) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/import-courses"), {
        school_id: school_id,
        file_id: file_id,
        test: test,
        column_mapping: column_mapping,
        course_type_mapping: course_type_mapping,
        instructor_mapping: instructor_mapping,
    });
};
exports.startCourseImport = startCourseImport;
var getCourseImportStatus = function (school_id, import_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/course-import/").concat(import_id, "/status"));
};
exports.getCourseImportStatus = getCourseImportStatus;
